import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Guard that only allows superadmin users.
 * Non-admins are redirected to /app.
 */
export default function RequireAdmin({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  const adminScopes = Array.isArray(user?.admin_scopes) ? user.admin_scopes : [];
  const hasBlogAdmin = adminScopes.includes("blog");
  const canAccessAdmin =
    !!user?.is_superadmin ||
    (hasBlogAdmin && location.pathname.startsWith("/admin/blog"));

  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessAdmin) {
    return <Navigate to={hasBlogAdmin ? "/admin/blog" : "/app"} replace />;
  }

  return children;
}
